<template>
    <div id="app">
      <router-view></router-view>
    </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
      timeoutId: null,
    };
  },
  methods:{
    startAutoLogout() {
      this.timeoutId = setTimeout(() => {
        this.$router.push({ path: '/login' });
        this.$message({
          type: 'warning',
          message: '一小时未操作请重新登录'
        })
      }, 60 * 60*1000);
    },
    resetAutoLogout() {
      clearTimeout(this.timeoutId);
      this.startAutoLogout();
    },
    addGlobalEventListeners() {
      window.addEventListener('mousemove', this.resetAutoLogout);
      window.addEventListener('keydown', this.resetAutoLogout);
      window.addEventListener('touchstart', this.resetAutoLogout);
    },
    removeGlobalEventListeners() {
      window.removeEventListener('mousemove', this.resetAutoLogout);
      window.removeEventListener('keydown', this.resetAutoLogout);
      window.removeEventListener('touchstart', this.resetAutoLogout);
    },
  },
  created() {
    this.startAutoLogout();
    this.addGlobalEventListeners();
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
    this.removeGlobalEventListeners();
  }

}
</script>


<style>
#app {
  font-size: 18px;
}
</style>
